import { render, staticRenderFns } from "./HeaderVideo.vue?vue&type=template&id=0cf37041&scoped=true"
import script from "./HeaderVideo.vue?vue&type=script&lang=js"
export * from "./HeaderVideo.vue?vue&type=script&lang=js"
import style0 from "./HeaderVideo.vue?vue&type=style&index=0&id=0cf37041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf37041",
  null
  
)

export default component.exports